export default "https://cdn-static.gokick.com/assets/672a5c69b0b224f66a9a6ac0576938eca42c1cee/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";